import React, { useState } from 'react';
import { TouchableOpacity, Text, StyleSheet, ActivityIndicator, Platform, Animated } from 'react-native';
import { useTheme } from '../context/ThemeContext';

const PrimaryButton = ({ title, disabled, loading, style, textStyle, indicatorColor, ...props }) => {
  const { palette } = useTheme();
  const [scaleAnim] = useState(new Animated.Value(1));
  const [isHovered, setIsHovered] = useState(false);

  const handlePressIn = () => {
    Animated.spring(scaleAnim, {
      toValue: 0.96,
      useNativeDriver: true,
      speed: 50,
    }).start();
  };

  const handlePressOut = () => {
    Animated.spring(scaleAnim, {
      toValue: 1,
      useNativeDriver: true,
      speed: 50,
    }).start();
  };

  const webHoverStyle = Platform.OS === 'web' && isHovered && !disabled && !loading
    ? {
        transform: [{ scale: 1.02 }],
        ...Platform.select({
          web: {
            boxShadow: `0 4px 20px ${palette.primary}80`,
            transition: 'all 0.2s ease',
          },
        }),
      }
    : {};

  return (
    <Animated.View
      style={{
        transform: [{ scale: scaleAnim }],
      }}
    >
      <TouchableOpacity
        style={[
          styles.button,
          { backgroundColor: '#18B3B7' },
          (disabled || loading) && styles.buttonDisabled,
          webHoverStyle,
          style,
        ]}
        disabled={disabled || loading}
        onPressIn={handlePressIn}
        onPressOut={handlePressOut}
        onMouseEnter={Platform.OS === 'web' ? () => setIsHovered(true) : undefined}
        onMouseLeave={Platform.OS === 'web' ? () => setIsHovered(false) : undefined}
        {...props}
      >
        {loading ? (
          <ActivityIndicator size="small" color={indicatorColor || palette.contrastText || '#000'} />
        ) : (
          <Text style={[styles.text, textStyle, { color: '#F1F1F1' }]}>{title}</Text>
        )}
      </TouchableOpacity>
    </Animated.View>
  );
};

const styles = StyleSheet.create({
  button: {
    alignSelf: 'stretch',
    height: 52,
    paddingVertical: 8,
    borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
  ...Platform.select({
        web: {
            boxShadow: '5px 7px 0px rgba(0,0,0,1)',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
        },
        default: {
            shadowColor: '#000000',
            shadowOffset: { width: 5, height: 7 },
            shadowOpacity: 1,
            shadowRadius: 0,
            elevation: 8,
        },
    }),
  },
  buttonDisabled: {
    opacity: 0.6,
    ...Platform.select({
      web: {
        cursor: 'not-allowed',
      },
    }),
  },
  text: {
    fontSize: 18,
    fontFamily: 'Chivo',
    fontWeight: '400',
    lineHeight: 20,
     ...Platform.select({
            web: {
                textShadow: '2px 2px 1px rgba(0,0,0,1)',
            },
            default: {
                textShadowColor: 'rgba(0,0,0,1)',
                textShadowOffset: { width: 2, height: 2 },
                textShadowRadius: 1,
            },
        }),
  },
});

export default PrimaryButton;


